import React, { useState, useEffect } from "react";
import { Table, Image, Button, Modal } from "react-bootstrap";
import ReactStars from "react-rating-stars-component";
import BasicPagination from "../../../../../Pagination/Pagination";
import moment from "moment";
import { ORDER_TYPE, PAYMENT_TYPE } from "../../../../../../enums/OrderEnums";
import { NOTAVAILABLEIMAGE } from "../../../../../../enums/GlobalEnums";

const orderTypes = [
  "Takeaway",
  "Curbside",
  "Skip the Line",
  "Dine-In",
  "Buffet",
  "Catering",
  "Drivethru",
  "Homedelivery",
];
const AllReviewPageInsideComponent = (props) => {
  //state
  const [showView, setShowView] = useState(false);
  const [page, setPage] = useState(1);
  const handleCloseView = () => setShowView(false);
  const [modalIndex, showModalIdnex] = useState(0);
  const handleShowView = (index) => {
    showModalIdnex(index);
    setShowView(true);
  };

  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  let filteredData = props.data;

  filteredData = filteredData.filter((item) => {
    return (
      (item &&
        item.restaurant_id &&
        item.restaurant_id.restaurant_name &&
        item.restaurant_id.restaurant_name
          .toLowerCase()
          .includes(props.search.toLowerCase())) ||
      (item &&
        item.restaurant_id &&
        item.restaurant_id.city.includes(props.search.toLowerCase()))
    );
  });

  if (props.sortBy === "Date & Time 🠑") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );
  } else if (props.sortBy === "Date & Time 🠓") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
    );
  } else if (props.sortBy === "A-Z") {
    filteredData = filteredData?.sort((a, b) =>
      a.restaurant_id?.restaurant_name > b.restaurant_id?.restaurant_name
        ? 1
        : -1
    );
  } else if (props.sortBy === "Z-A") {
    filteredData = filteredData?.sort((a, b) =>
      b.restaurant_id?.restaurant_name > a.restaurant_id?.restaurant_name
        ? 1
        : -1
    );
  }

  if (props.filterBy) {
    if (props?.filterBy?.value)
      filteredData = filteredData?.filter(
        (ele) => ele.rating == props?.filterBy?.value
      );
    if (props.filterBy.location)
      filteredData = filteredData?.filter(
        (ele) =>
          ele.restaurant_id?.city?.toLowerCase() ===
          props?.filterBy?.location?.toLowerCase()
      );
    if (props?.filterBy?.through === 0)
      filteredData = filteredData?.filter(
        (ele) => ele?.order_id?.order_type === props?.filterBy?.through
      );
    else if (props?.filterBy?.through === 1)
      filteredData = filteredData?.filter(
        (ele) => ele?.order_id?.order_type === props?.filterBy?.through
      );
    else if (props?.filterBy?.through === 2)
      filteredData = filteredData?.filter(
        (ele) => ele?.order_id?.order_type === props?.filterBy?.through
      );
    else if (props?.filterBy?.through === 3)
      filteredData = filteredData?.filter(
        (ele) => ele?.order_id?.order_type === props?.filterBy?.through
      );
    else if (props?.filterBy?.through === 4)
      filteredData = filteredData?.filter(
        (ele) => ele?.order_id?.order_type === props?.filterBy?.through
      );
    else if (props?.filterBy?.through === 5)
      filteredData = filteredData?.filter(
        (ele) => ele?.order_id?.order_type === props?.filterBy?.through
      );
    else if (props?.filterBy?.through === 6)
      filteredData = filteredData?.filter(
        (ele) => ele?.order_id?.order_type === props?.filterBy?.through
      );
    else if (props?.filterBy?.through === 7)
      filteredData = filteredData?.filter(
        (ele) => ele?.order_id?.order_type === props?.filterBy?.through
      );
    else if (props?.filterBy?.through === "SEATING")
      filteredData = filteredData?.filter(
        (ele) => ele?.diner_id?.service_type === props?.filterBy?.through
      );
    else if (props?.filterBy?.through === "RESERVATION")
      filteredData = filteredData?.filter(
        (ele) => ele?.diner_id?.service_type === props?.filterBy?.through
      );
    else if (props?.filterBy?.through === "SCAN_AND_PAY")
      filteredData = filteredData?.filter(
        (ele) =>
          ele?.transactional_id?.transaction_type === props?.filterBy?.through
      );
    else if (props?.filterBy?.through === "WALLET")
      filteredData = filteredData?.filter(
        (ele) =>
          ele?.transactional_id?.transaction_type === props?.filterBy?.through
      );
    else if (props?.filterBy?.through === "RAZORPAY")
      filteredData = filteredData?.filter(
        (ele) =>
          ele?.transactional_id?.transaction_type === props?.filterBy?.through
      );
  }

  filteredData = filteredData.filter((item) => {
    return (
      (props.selectedTab === "1" && item.type === 0 ? true : false) ||
      (props.selectedTab === "2" && item.type === 1 ? true : false) ||
      (props.selectedTab === "3" && item.type === 2 ? true : false) ||
      (props.selectedTab === "4" && item.type === 3 ? true : false) ||
      (props.selectedTab === "5" && item.type === 4 ? true : false) ||
      (props.selectedTab === "6" && item.type === 5 ? true : false)
    );
  });

  // if (props.startDate && props.endDate && props.clickedSearch) {
  //   let ed = new Date(props.endDate).getTime();
  //   let sd = new Date(props.startDate).getTime();

  //   filteredData = filteredData.filter((d) => {
  //     var time = new Date(d.createdAt).getTime();
  //     return sd < time && time < ed;
  //   });
  // } 

  // if (props.sortByDay !== 4) {
  //   filteredData = filteredData.filter((item) => {
  //     return (
  //       (props.startDay <= moment(item.createdAt).format("YYYY-MM-DD") ||
  //         props.startDay <= moment(item.updatedAt).format("YYYY-MM-DD")) &&
  //       (moment(item.createdAt).format("YYYY-MM-DD") <= props.endDay ||
  //         moment(item.updatedAt).format("YYYY-MM-DD") <= props.endDay)
  //     ); 
  //   });
  // }

  // useEffect(() => {
  //   if (props.data) {
  //     // const items = props.data.nominations;
  //     // const reversedItems = items.map((item) => item).reverse();
  //     // setNominations(reversedItems);

  //     // let sortedDates = props.data.sort(function (a, b) {
  //     //   return new Date(b.updatedAt) - new Date(a.updatedAt);
  //     // });
  //     let sortedDates = [];

  //     if (props.sortByDate === 1) {
  //       sortedDates = props.data.sort(function (a, b) {
  //         return new Date(b.updatedAt) - new Date(a.updatedAt);
  //       });
  //     } else {
  //       sortedDates = props.data.sort(function (a, b) {
  //         return new Date(a.updatedAt) - new Date(b.updatedAt);
  //       });
  //     }
  //     setReviews(sortedDates);
  //   }
  // }, [props.data, props.sortByDate]);

  return (
    <React.Fragment>
      <div className="col-12 p-0 user-table-reusable-superadmin table-responsive ">
        <Table className="enMinWidth900">
          <thead>
            <tr className="super_admin_all_users_table_head">
              <td style={{ width: "15%" }} className="f12-500">
                Restaurant <br /> Name
              </td>
              <td style={{ width: "10%" }} className="f12-500">
                Location
              </td>
              {props?.selectedTab === '5' && (
                 <td style={{ width: "15%" }} className="f12-500">
                 Item Name/ <br />Photo
               </td>
              ) }
              <td style={{ width: "30%" }} className="f12-500">
                Review/comment
              </td>
              <td style={{ width: "20%" }} className="f12-500">
                Rating- <br /> Date & Time
              </td>
              {props.selectedTab === "2" && (
                <td style={{ width: "15%" }} className="f12-500">
                  Diner ID /<br /> Diner Type
                </td>
              )}
              {props.selectedTab === "3" && (
                <>
                  <td style={{ width: "15%" }} className="f12-500">
                    Experience
                  </td>{" "}
                  <td style={{ width: "15%" }} className="f12-500">
                    Experience Type /<br /> Experience Id
                  </td>
                </>
              )}
              {props.selectedTab === "5" && (
                <>
                  {/* <th style={{ width: "15%" }} className="f12-700">
                    Item
                  </th> */}
                 
                  <td style={{ width: "15%" }} className="f12-500">
                    Order ID /<br /> Order Type
                  </td>
                </>
              )}
              {props.selectedTab === "4" && (
                <>
                  <td style={{ width: "15%" }} className="f12-500">
                    No. of Items
                  </td>
                  <td style={{ width: "15%" }} className="f12-500">
                    Order ID /<br /> Order Type
                  </td>
                </>
              )}
              {props.selectedTab === "6" && (
                <>
                  <td style={{ width: "15%" }} className="f12-500">
                    Payment Type / <br /> Transaction Id
                  </td>
                </>
              )}
            </tr>
          </thead>
          <tbody className="HideShowTable">
            {filteredData.slice(start, end).map((review, index) => (
              <tr
                className="super_admin_all_users_table_body super_admin_user_view_inside_table_body"
                key={index}
              >
                <td style={{ width: "15%" }}>
                  <div className="d-flex flex-column align-items-start">
                    <div className="enImage45 ">
                      <Image
                        //src={require("../../../../../../assets/images/UserManagement/fhr7.png")}
                        src={review.restaurant_id.logo_url || NOTAVAILABLEIMAGE}
                        alt="View"
                        title="View"
                        fluid
                      />
                    </div>
                    <div className="f11-500 text-center mt-1">
                      {review.restaurant_id.restaurant_name}
                    </div>
                  </div>
                </td>
                <td style={{ width: "10%" }}>
                  <div className="f12-400">{review.restaurant_id.city}</div>
                </td>
                {props?.selectedTab === "5" && (
                  <td style={{ width: "15%" }} className="f12-700">
                  <div className="enImage45 ">
                    <Image
                      //src={require("../../../../../../assets/images/UserManagement/fhr7.png")}
                      src={
                        review.item_id?.image_thumbnails[0] ||
                        review.item_id?.images[0] ||
                        NOTAVAILABLEIMAGE
                      }
                      alt="View"
                      title="View"
                      fluid
                    />
                  </div>
                  <div className="f12-400 mb-2 ml-2">
                    {review.item_id?.name}
                  </div>
                </td>
                )}
                <td style={{ width: "30%" }}>
                  <div className="f12-400">{review.review}</div>
                  <div className="d-flex align-items-center">
                    <div className={"mr-2 ml-2"}>
                      <Image
                        src={require("../../../../../../assets/images/UserManagement/thumbs-up.svg")}
                        alt="View"
                        title="View"
                        width="12px"
                      />
                      <div className="f11-400 mb-2 ml-2">
                        {review.likes.length}
                      </div>
                    </div>
                    <div className={"mr-2 ml-2"}>
                      <Image
                        src={require("../../../../../../assets/images/UserManagement/thumbs-down.svg")}
                        alt="View"
                        title="View"
                        width="12px"
                      />
                      <div className="f11-400 mb-2 ml-2">
                        {review.dislikes.length}
                      </div>
                    </div>
                    <div className={"mr-2 ml-2"}>
                      <Image
                        src={require("../../../../../../assets/images/UserManagement/message-square.svg")}
                        alt="View"
                        title="View"
                        width="12px"
                      />
                      <div className="f11-400 mb-2 ml-2">
                        {" "}
                        {review.comment.length}
                      </div>
                    </div>
                  </div>
                </td>
                <td style={{ width: "20%" }}>
                  <div className="f12-400 mb-2 ml-2">
                    {review?.rating} Rating
                  </div>
                  <ReactStars
                    count={review.rating}
                    edit={false}
                    value={5}
                    size={18}
                    half={true}
                    emptyIcon={<i className="far fa-star"></i>}
                    halfIcon={<i className="fa fa-star-half-alt"></i>}
                    fullIcon={<i className="fa fa-star"></i>}
                    color2={"#FCB614"}
                  />
                  <div className="f10-400 mb-2 ml-2">
                    {moment(review?.createdAt).format("lll")}
                  </div>
                </td>
                {props.selectedTab === "2" && (
                  <td style={{ width: "15%" }} className="f12-700">
                    <div className="f12-400 mb-2 ml-2">
                      {review.diner_id?.diner_id}
                    </div>{" "}
                    <br />
                    <div className="f12-400 mb-2 ml-2">
                      {review.diner_id?.service_type == "RESERVATION"
                        ? "Reservation"
                        : "Seating"}
                    </div>
                  </td>
                )}
                {props.selectedTab === "3" && (
                  <>
                    <td style={{ width: "15%" }} className="f12-700">
                      <div className="enImage45 ">
                        <Image
                          //src={require("../../../../../../assets/images/UserManagement/fhr7.png")}
                          src={
                            review.event_id?.photo_thumbnails[0] ||
                            review.event_id?.photos[0]
                          }
                          alt="View"
                          title="View"
                          fluid
                        />
                      </div>
                      <div className="f12-400 mb-2 ml-2">
                        {review.event_id?.name}
                      </div>{" "}
                    </td>{" "}
                    <td style={{ width: "15%" }} className="f12-700">
                      <div className="f10-400 mb-2 ml-2">
                        {review.event_id?.event_id}
                      </div>
                    </td>
                  </>
                )}
                {props.selectedTab === "5" && (
                  <>
                    
                    {/* <td style={{ width: "15%" }} className="f12-700">
                      
                    </td> */}
                    <td style={{ width: "15%" }} className="f12-700">
                      <div className="f12-400 mb-2 ml-2">
                        {ORDER_TYPE[review.order_id?.order_type]}
                      </div>
                      <br />
                      <div className="f10-400 mb-2 ml-2">
                        {review.order_id?.order_id}
                      </div>
                    </td>
                  </>
                )}
                {props.selectedTab === "4" && (
                  <>
                    <td style={{ width: "15%" }} className="f12-700">
                      <div className="f12-400 mb-2 ml-2">
                        {review?.order_id?.order_items?.length}
                      </div>
                    </td>
                    <td style={{ width: "15%" }} className="f12-700">
                      <div className="f12-400 mb-2 ml-2">
                        {ORDER_TYPE[review.order_id?.order_type]}
                      </div>
                      <br />
                      <div className="f10-400 mb-2 ml-2">
                        {review.order_id?.order_id}
                      </div>
                    </td>
                  </>
                )}
                {props.selectedTab === "6" && (
                  <>
                    <td style={{ width: "15%" }} className="f12-700">
                      <div className="f12-400 mb-2 ml-2">
                        {review.transactional_id?.transaction_type ===
                        "SCAN_AND_PAY"
                          ? "Scan & Pay"
                          : review.transactional_id?.transaction_type ===
                            "WALLET"
                          ? "Wallet"
                          : review.transactional_id?.transaction_type ===
                            "RAZORPAY"
                          ? "Razorpay"
                          : ""}
                      </div>
                      <br />
                      <div className="f12-400 mb-2 ml-2">
                        {review?.transactional_id?.transactionNumber ||
                          review?.transactional_id?._id}
                      </div>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      {filteredData.length !== 0 ? (
        <BasicPagination
          totalRecords={filteredData.length}
          limit={10}
          batch={page}
          onBatchChange={(e) => handleBatchChange(e)}
        />
      ) : (
        <> </>
      )}
      <Modal show={showView} onHide={handleCloseView} centered>
        <Modal.Header className="border-0 px-md-4" closeButton>
          <Modal.Title className="f18-700">Review Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-md-4">
          <div className="f15-500 pb-3">Review Comments</div>
          <div className="enGrayBorderBox p-3 f12-400">
            {filteredData[modalIndex] && filteredData[modalIndex].review}
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default AllReviewPageInsideComponent;
